import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Security } from "@/components/Security";
import { ClosingOptions } from "@/components/ClosingOptions";
import { Team } from "@/components/Team";
import { Audiences } from "@/components/Audiences";
import { Underwriters } from "@/components/Underwriters";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Calculator } from "@/components/Calculator";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF9]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <Security />
        <ClosingOptions />
        <Audiences />
        <Team />
        <Underwriters />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
